/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.TransactionsHistoryResponse,
  TransactionsHistory: (params: vp.TransactionsHistoryRequest) => void,
  TransactionsHistoryAsync: (params: vp.TransactionsHistoryRequest) => Promise<vp.TransactionsHistoryResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchTransactionsHistory: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldTransactionsHistory, setShouldTransactionsHistory] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.TransactionsHistoryRequest>({
    PortalUser: '',
    StartDateTime: '',
    EndDateTime: '',
    Currency: '',
  });
  const [response, setResponse] = useState<vp.TransactionsHistoryResponse>({
    Success: false,
    ErrorMessage: '',
    NumberOfRecords: 0,
    Transactions: [],
  });

  useEffect(() => {
    if (!shouldTransactionsHistory) return () => {};

    const fetchTransactionsHistory = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchTransactionsHistory(params, source);
      setResponse(res);
      setDataFetchingInfo(false, 'loading some data', 'fullScreen');
    };

    if (shouldTransactionsHistory) void fetchTransactionsHistory();
    setShouldTransactionsHistory(false);
    return () => {
      source.cancel();
    };
  }, [shouldTransactionsHistory]);

  return [
    response,
    (_params: vp.TransactionsHistoryRequest) => {
      setParams(_params);
      setShouldTransactionsHistory(true);
    },
    async (_params: vp.TransactionsHistoryRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.fetchTransactionsHistory(_params, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        NumberOfRecords: 0,
        Transactions: [],
      });
      setShouldTransactionsHistory(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchTransactionsHistory);
